<template>
  <div :class="{ modal: show, danger: show }">
    <div class="inner" v-if="show">
      <div class="flex flex-col">
        <div class="confirm-title">
          {{ title }}
        </div>
        <div class="actions flex items-center justify-around">
          <button class="btn green-white" type="button" @click="$emit('cancel')">Cancel</button>
          <button class="btn danger" type="button" @click="$emit('confirm')">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmActionModal',
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
.inner {
  padding: 0;
  max-width: 500px;
}

.confirm-title {
  color: #F25837;
  font-size: 1.125rem;
  font-weight: 700;
  text-align: center;
  padding: 24px 24px 16px;
  border-bottom: 1px solid #E2E4E6;
}

.actions {
  gap: 16px;
  padding: 24px;

  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 120px;
    height: 2.5rem;
    font-size: 0.875rem;
    font-weight: 600;
    border-radius: 8px;
    padding: 0.5rem 1.25rem;
    cursor: pointer;
    border: 1px solid transparent;
  }

  .green-white {
    color: #fff;
    background: #1FBC2F;
    border-color: #1FBC2F;
    &:hover {
      background: rgba(31, 188, 47, 0.85);
    }
  }

  .danger {
    color: #F25837;
    background: #fff;
    border-color: #F25837;
    &:hover {
      background: rgba(242, 88, 55, 0.08);
    }
  }
}
</style>
